import { compact } from "lodash";
import toggleHelper from "./togglehelper";
import MenuToggle from './menutoggle';

export default class Navigation {
  constructor(element) {
    // DECLARATION OF ALL VARIABLES
    // this.menuItemClass = element.getAttribute("data-toggle-menu-item");
    // this.menuContainersClass = element.getAttribute(
    //   "data-toggle-menu-containers",
    // );
    this.searchButtonClass = element.getAttribute("data-toggle-search");
    this.searchFormClass = element.getAttribute("data-search-form");
    this.closeSearchFormClass = element.getAttribute("data-close-search");
    // this.subMenuClass = element.getAttribute("data-toggle-sub-menu");

    // this.menuItems = Array.from(
    //   element.getElementsByClassName(this.menuItemClass),
    // );
    // this.menuContainers = Array.from(
    //   element.getElementsByClassName(this.menuContainersClass),
    // );
    this.searchButtons = Array.from(
      document.getElementsByClassName(this.searchButtonClass),
    );
    this.searchForm = document.getElementsByClassName(this.searchFormClass)[0];
    this.closeSearchFormButton = document.getElementsByClassName(
      this.closeSearchFormClass,
    )[0];
    // this.subMenu = Array.from(
    //   document.getElementsByClassName(this.subMenuClass),
    // );
    // this.closeButtons = Array.from(
    //   document.getElementsByClassName(".main-navigation__close"),
    // );

    // this.openedMenus = [];
    // this.currentMenuContainer = false;
    this.helper = new toggleHelper();
    // this.selectedMenu = null;
    // this.selectedSearchButton = null;
    // this.containerItems = [];
    // this.itemsToNavigate = [];

    // window.addEventListener("resize", (e) => {
    //   this.updateSelectedMenu();
    //   this.updateSelectedSearchButton();
    // });

    // element.addEventListener("click", (e) => {
    //   this.toggleMenu(e.target);
    // });

    // this.subMenu.map((item) => {
    //   item.addEventListener("click", (e) => {
    //     this.helper.toggleAttr(e.target, [e.target]);
    //     this.helper.toggleClass(e.target.closest("li"));
    //   });
    // });

    // this.navigateByKeyUp(element);
    // this.navigateByKeyDown(element);

    // this.activateMenu();

    this.searchButtons.map((item) =>
      item.addEventListener("click", (e) => {
        this.toggleSearchForm(this.searchButtons, e.target);
        onCloseMenu();
        const form = this.searchForm;
        setTimeout(function() {
          form.querySelector(".awesomplete input ").focus();
        }, 0);
      }),
    );

    this.closeSearchFormButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSearchForm(this.searchButtons);
      this.selectedSearchButton.focus();
    });

    // this.closeButtons.map((button) =>
    //   button.addEventListener("click", (e) => {
    //     const menuAttribute = button
    //       .closest("[data-child-parent]")
    //       .getAttribute("data-child-parent");
    //     const menuItem = document.querySelector(
    //       'button[data-parent="' + menuAttribute + '"]',
    //     );

    //     this.toggleMenu(menuItem);
    //   }),
    // );

    // document.addEventListener('click', (e) => {
    //   if (!this.openedMenus.length) return;

    //     const clickedItem = e.target;

    //   if (!this.menuItems.includes(clickedItem) && !this.currentMenuContainer.contains(clickedItem)) {

    //     this.helper.setExpandedFalse([
    //       this.selectedMenu,
    //       this.currentMenuContainer
    //     ]);
    //   }
    // })


    // MENU TOGGLE 2025
    const toggleButton = document.querySelector(".header__primary-menu-button");
    const menuContainer = document.querySelector(".main-navigation");
    const helper = new toggleHelper();
    toggleButton.addEventListener("click", () => {
      // Fetch scrollbar width, used as padding when scrollbar is hidden
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
      helper.toggleAttr(toggleButton, [toggleButton]);

      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        // Use your container as the root from which to query
        const activeItem = menuContainer.querySelector(".main-navigation__item--active");
        if (activeItem) {
          // Smooth scrolling to the active item
          // activeItem.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" });
          // Fast!
          activeItem.scrollIntoView({ block: "center", inline: "nearest" });
        }
      }

      menuContainer.setAttribute("aria-hidden", String(!isExpanded));
      menuContainer.classList.toggle("is-visible", isExpanded);

      document.addEventListener("keydown", onMenuKeydown);
    });

    // Close the menu when the close button is clicked
    const backdrop = document.querySelector(".main-navigation-backdrop");
    const filler = document.querySelector(".main-navigation-filler");
    const closeButton = document.querySelector(".main-navigation-button__close");
    const onMenuKeydown = (event) => {
      if (event.key === "Escape" && menuContainer.classList.contains("is-visible")) {
        onCloseMenu();
      }
    };
    const onCloseMenu = () => {
      menuContainer.classList.add('is-closing');
      setTimeout(function() {
        menuContainer.classList.remove("is-visible");
        menuContainer.classList.remove("is-closing");
      }, 400);

      menuContainer.setAttribute("aria-hidden", "true");
      backdrop.setAttribute("aria-hidden", "true");

      toggleButton.setAttribute("aria-expanded", "false");
      toggleButton.focus();

      document.removeEventListener("keydown", onMenuKeydown);
    };
    [closeButton, backdrop, filler].forEach((element) => {
      element.addEventListener("click", onCloseMenu);
    });

    // Toggle the submenus
    const allToggleButtons = document.querySelectorAll('.main-navigation__list-item-icon');

    allToggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const isRootLevel = button.classList.contains('main-navigation__root-toggle');

        if (isRootLevel) {
          document.querySelectorAll('.main-navigation__root-toggle[aria-expanded="true"]')
            .forEach(otherBtn => {
              if (otherBtn !== button) {
                // Close the other open root-level button
                otherBtn.setAttribute('aria-expanded', 'false');

                // Close the other root-level menu
                const otherMenuId = otherBtn.getAttribute('aria-controls');
                const otherMenuEl = document.getElementById(otherMenuId);
                if (otherMenuEl) {
                  otherMenuEl.setAttribute('aria-expanded', 'false');

                  // Close *all* sub-level toggles inside that menu
                  const subToggles = otherMenuEl.querySelectorAll(
                    '.main-navigation__list-item-icon:not(.main-navigation__root-toggle)'
                  );
                  subToggles.forEach(subToggle => {
                    subToggle.setAttribute('aria-expanded', 'false');
                    const subMenuId = subToggle.getAttribute('aria-controls');
                    const subMenuEl = document.getElementById(subMenuId);
                    if (subMenuEl) {
                      subMenuEl.setAttribute('aria-expanded', 'false');
                    }
                  });
                }
              }
            });
        }

        // Toggle the clicked button/menu
        const wasExpanded = button.getAttribute('aria-expanded') === 'true';
        const newState = !wasExpanded;
        button.setAttribute('aria-expanded', String(newState));

        const controlledMenuId = button.getAttribute('aria-controls');
        const controlledMenu = document.getElementById(controlledMenuId);
        if (controlledMenu) {
          controlledMenu.setAttribute('aria-expanded', String(newState));
          const level = button.dataset.level;
          const activeClass = `main-navigation__link-wrapper--active-${level}`;

          const linkWrapper = button.closest('.main-navigation__link-wrapper');
          const rootLinkWrapper = button.closest('.main-navigation__menu-item-link');
          const targetWrapper = linkWrapper || rootLinkWrapper;
          if (targetWrapper) {
            if (newState) {
              targetWrapper.classList.add(activeClass);
            } else {
              targetWrapper.classList.remove(activeClass);
            }
          }
          // If this is a root-level button we are closing, also close its sub-items
          if (isRootLevel && newState === false) {
            const subToggles = controlledMenu.querySelectorAll(
              '.main-navigation__list-item-icon:not(.main-navigation__root-toggle)'
            );
            subToggles.forEach(subToggle => {
              subToggle.setAttribute('aria-expanded', 'false');
              const subMenuId = subToggle.getAttribute('aria-controls');
              const subMenuEl = document.getElementById(subMenuId);
              if (subMenuEl) {
                subMenuEl.setAttribute('aria-expanded', 'false');
              }
            });
          }
          if (isRootLevel && newState) {
            // Remove active classes from other root-level link wrappers and menu-item-links
            document.querySelectorAll(
              '.main-navigation__link-wrapper[class*="main-navigation__link-wrapper--active-"], .main-navigation__menu-item-link[class*="main-navigation__link-wrapper--active-"]'
            ).forEach(wrapper => {
              if (wrapper !== targetWrapper) {
                wrapper.className = wrapper.className.replace(/main-navigation__link-wrapper--active-\S+/g, '');
              }
            });
          }
        }
      });
    });

    // LOGIN BUMP
    this.now = new Date();
    this.loginBumps = Array.from(
      document.getElementsByClassName("header__login-bump"),
    );
    this.loginBumpStorageKey = "login-bump";
    this.animationTimeout;
    this.loginBumpStorageValue = JSON.parse(
      localStorage.getItem(this.loginBumpStorageKey),
    );

    this.globalDisplayTime = 60 * 50 // 3secs
    this.loginButtons = Array.from(
      document.getElementsByClassName("header__login-button"),
    );

    this.asyncLoginBumpReveal();
  }

  // DECLARATION OF ALL FUNCTIONS

  // toggleMenu(target) {
  //   if (!target.classList.contains(this.menuItemClass)) return;

  //   let isTargetExpanded = target.getAttribute("aria-expanded");

  //   this.hideOpenedMenus(target);

  //   if (isTargetExpanded == "true") return;

  //   this.menuItems.map((item) => {
  //     if (this.helper.hasSameParent(target, item)) {
  //       this.openedMenus.push(item);

  //       this.updateSelectedMenu();

  //       this.toggleMenuItems(item);

  //       // hide searchform
  //       this.helper.setExpandedFalse([this.searchForm]);
  //       this.helper.hideContainer(this.searchButtons);

  //       this.helper.toggleAttr(item, [item]);
  //     }
  //   });
  // }

  // toggleMenuItems(selectedItem) {
  //   this.menuContainers.map((item) => {
  //     let parent = selectedItem.getAttribute("data-parent").toLowerCase();

  //     let itemParent = item.getAttribute("data-child-parent").toLowerCase();

  //     this.helper.setExpandedFalse([item]);

  //     if (itemParent === parent) {
  //       this.currentMenuContainer = item;

  //       return this.helper.toggleAttr(selectedItem, [item]);
  //     }
  //   });
  // }

  // hideOpenedMenus(target) {
  //   this.menuContainers.map((item) => {
  //     this.helper.setExpandedFalse([item]);
  //   });

  //   this.openedMenus.map((menu) => {
  //     this.helper.setExpandedFalse([menu]);
  //   });

  //   this.currentMenuContainer = false;
  //   this.openedMenus.length = 0;
  // }

  toggleSearchForm(items) {
    this.updateSelectedSearchButton();

    items.map((item) => {
      this.helper.toggleAttr(item, [item, this.searchForm]);
    });
  }

  // navigateByKeyUp(element) {
  //   document.addEventListener("keyup", (evt) => {
  //     const focusedItem = document.activeElement;


  //     if (!element.contains(focusedItem)) return;

  //     this.getItemsToNavigate();

  //       switch (evt.key.toLowerCase()) {
  //         case "enter":
  //           if (this.openedMenus.length && focusedItem == this.selectedMenu) {
  //             this.itemsToNavigate[0].focus();
  //           }
  //           break;
  //         case "escape":
  //           if (
  //             this.openedMenus.length &&
  //             (this.currentMenuContainer.contains(focusedItem) || this.menuItems.includes(focusedItem))
  //           ) {
  //             this.helper.setExpandedFalse([
  //               this.selectedMenu,
  //               this.currentMenuContainer,
  //             ]);
  //             this.selectedMenu.focus();
  //           }

  //           if (this.searchForm.contains(focusedItem)) {
  //             this.closeSearchFormButton.click();
  //           }
  //           break;
  //         case " ":
  //           if (focusedItem.classList.contains(this.menuItemClass)) {
  //             evt.preventDefault();

  //             focusedItem.click();

  //             this.getItemsToNavigate();

  //             if (this.helper.isExpanded(focusedItem)) {
  //               this.itemsToNavigate[0].focus();
  //             }
  //           }

  //           break;
  //         case "end":
  //           if (this.openedMenus.length) {
  //             this.itemsToNavigate[this.itemsToNavigate.length - 1].focus();
  //           }
  //           break;
  //         case "home":
  //           if (this.openedMenus.length) {
  //             this.itemsToNavigate[0].focus();
  //           }
  //           break;
  //         case "arrowup":
  //           if (this.openedMenus.length) {
  //             this.itemToFocusOn(this.itemsToNavigate, "keyup");
  //           }

  //           break;
  //         case "arrowdown":
  //           if (this.openedMenus.length) {
  //             this.itemToFocusOn(this.itemsToNavigate, "keydown");
  //           }
  //           break;
  //       }
  //   });
  // }

  // navigateByKeyDown(element) {
  //   document.onkeydown = function (evt) {
  //     const focusedItem = document.activeElement;

  //     if (!element.contains(focusedItem)) return;

  //     //stop default behavior on arrow up and arrow down key
  //       switch (
  //         evt.key.toLowerCase() // check which key is pressed
  //       ) {
  //         case "arrowdown":
  //         case "arrowup":
  //           evt.preventDefault();
  //           break;
  //       }
  //   };
  // }

  // filterItemsToNavigate(items) {
  //   let itemsToNavigate = items.filter((item) => {
  //     let isItemNavigable = true;
  //     let extendedItem = item.closest(".main-navigation__item--has-children.is-expanded");


  //     if ((item.classList.contains("main-navigation__child") || item.classList.contains("main-navigation__button--recursive")) && !extendedItem ) {
  //       isItemNavigable = false;
  //     }

  //     if (isItemNavigable && extendedItem) {
  //       let itemParent = item;

  //       while (
  //         itemParent.parentNode &&
  //         itemParent.parentNode.nodeName.toLowerCase() !== "ul"
  //       ) {
  //         itemParent = itemParent.parentNode;
  //       }

  //       isItemNavigable = (itemParent.parentNode == extendedItem.parentNode) || (itemParent.parentNode == extendedItem.querySelector("ul") ) ;
  //     }


  //     return isItemNavigable;
  //   });



  //   return itemsToNavigate.map((item) => {
  //     return item.tagName == "LI" ? item.querySelector("a") : item;
  //   });
  // }

  // itemToFocusOn(items, type) {
  //   let currentIndex = items.length;

  //   if (type === "keyup") {
  //     // give currentIndexUp variable right value
  //     for (let index = 0; index < items.length; index++) {
  //       if (index !== 0 && this.isListItemFocused(items[index])) {
  //         currentIndex = index;

  //         break; // end loop when correct match is found
  //       }
  //     }
  //     // give right dropdown item focus
  //     items[currentIndex - 1].focus();
  //   }

  //   if (type === "keydown") {
  //     currentIndex = -1;

  //     for (let index = 0; index < items.length; index++) {
  //       if (
  //         this.isListItemFocused(items[index]) &&
  //         index !== items.length - 1
  //       ) {
  //         currentIndex = index;
  //         break; // end loop when correct match is found
  //       }
  //     }

  //     items[currentIndex + 1].focus();
  //   }
  // }

  // updateSelectedMenu() {
  //   this.selectedMenu =
  //     document.body.offsetWidth > 1040
  //       ? this.openedMenus[0]
  //       : this.openedMenus[1];
  // }

  updateSelectedSearchButton() {
    this.selectedSearchButton =
      document.body.offsetWidth > 1040
        ? this.searchButtons[0]
        : this.searchButtons[1];
  }

  // isListItemFocused = (item) => {
  //   return document.activeElement == item;
  // };

  // getItemsToNavigate() {
  //   this.containerItems =
  //     this.openedMenus.length &&
  //     Array.from(
  //       this.currentMenuContainer.querySelectorAll(
  //         ".main-navigation__items li, .main-navigation__items .main-navigation__button",
  //       ),
  //     );

  //   this.itemsToNavigate = this.openedMenus.length
  //     ? this.filterItemsToNavigate(this.containerItems)
  //     : [];
  // }

  // activateMenu() {
  //   let activeContainer = this.menuContainers.some((container) => {
  //     return container.querySelector('a[aria-current="page"]');
  //   });

  //   if (!activeContainer) return;

  //   this.menuContainers.map((container) => {
  //     const activeChild = container.querySelector('a[aria-current="page"]');

  //     if (!activeChild) return;

  //     this.menuItems.map((item) => {
  //       if (
  //         item.getAttribute("data-parent").toLowerCase() ==
  //         container.getAttribute("data-child-parent").toLowerCase()
  //       ) {
  //         item.classList.add("active");
  //       }
  //     });

  //     this.activateMenuItem(activeChild);
  //   });
  // }

  // activateMenuItem(activeItem) {
  //   activeItem = activeItem.closest("li");
  //   let activeItemParents = [];

  //   while (
  //     activeItem.parentNode &&
  //     activeItem.parentNode.nodeName.toLowerCase() !== "nav"
  //   ) {
  //     activeItem = activeItem.parentNode;

  //     activeItemParents.push(activeItem);
  //   }

  //   activeItemParents = activeItemParents.filter((parent) => {
  //     return parent.classList.contains(".main-navigation__item--has-children");
  //   });

  //   activeItemParents.map((parent) => {
  //     const parentButton = parent.querySelector(".main-navigation__button");
  //     this.helper.toggleClass(parent, [parent]);
  //     this.helper.toggleAttr(parentButton, [parentButton]);
  //   });
  // }



  // LOGIN BUMP

  asyncLoginBumpReveal = async () => {
    if (!this.loginBumps) return;

    // add function to hide bump on login button click
    this.loginButtons.map((button) => {
      button.addEventListener("click", (e) => {
        this.setBumpStorage(this.now.getTime());
      });
    });

    // on page load, if there is an expiry date set in localstorage and it hasn't expired
    if (
      this.loginBumpStorageValue &&
      this.now.getTime() < this.loginBumpStorageValue.expiryTime
    ) {
      // we hide the bumps if the displaytime has run it's course.
      if (this.now.getTime() > this.loginBumpStorageValue.displayTime) {
        this.hideBumps();
      } else {
        // we show the bumps since there is remaining time
        this.showBumps();

        const remainingDisplayTime =
          this.loginBumpStorageValue.displayTime - this.now.getTime();
        // then we hide it again after remaining time is over
        setTimeout(() => {
          this.hideBumps();
        }, remainingDisplayTime);
      }
      return;
    }

    // on page load if there is nothing stored we show the bumps and store it, if it exists and has expired, we update
    this.showBumps();

    const success = await this.setBumps();

    if (success) {
      // the first time the bumps are revealed, we use a timer

     setTimeout(() => {
        this.hideBumps();
      }, this.globalDisplayTime);
    }
  };

  setBumps() {
    return new Promise((resolve) => {
      this.setBumpStorage(this.now.getTime() + this.globalDisplayTime);

      resolve(true);
    });
  }

  hideBumps() {
    clearTimeout(this.animationTimeout);

    this.loginBumps.map((bump) => {
      bump.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 1000,
      });

      this.animationTimeout = setTimeout(() => {
        bump.classList.add("u-display-none");
      }, 1000);
    });
  }

  showBumps() {
    clearTimeout(this.animationTimeout);

    this.loginBumps.map((bump) => {
      this.animationTimeout = setTimeout(() => {
        bump.classList.remove("u-display-none");
      }, 0);

      bump.animate(
        [
          { transform: "scale(0.8)" },
          { transform: "scale(0.9)" },
          { transform: "scale(0.98)" },
          { transform: "scale(0.9)" },
          { transform: "scale(1)" },
        ],
        {
          duration: 600,
        },
      );
    });
  }

  setBumpStorage(displayTime) {
    localStorage.setItem(
      this.loginBumpStorageKey,
      JSON.stringify({
        expiryTime: this.now.getTime() + 2 * (24 * (60 * 60 * 1000)), // 2 days
        displayTime: displayTime,
      }),
    );
  }
}
